// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { ENQUIRY_CTA } from "../constants";
import { useEnquiryModal } from "./EnquiryModal";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="Assets/a1.webp"
            alt="Luxury View"
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            Meraas Solaya Dubai
          </h2>
          <p>
            Meraas Solaya is an exclusive collection of 234 luxury residences along the prestigious Jumeirah coastline, offering uninterrupted sea and skyline views. Developed with Meraas and Brookfield Properties, it blends coastal tranquility with quick access to Dubai’s vibrant lifestyle. Residents enjoy direct beach access, landscaped gardens, and the central Beach Park, along with premium amenities including a spa, gym, cinema, lounge, and meeting spaces. Solaya by Meraas is located beside the iconic J1 Beach, home to world-class dining and beach clubs, Solaya delivers a refined, Riviera-inspired lifestyle in one of Dubai’s most coveted beachfront destinations.
          </p>
          <button onClick={() => openModal(ENQUIRY_CTA.INTRO)} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>
    </div>
  );
};

export default LuxuryPage;
